module.exports = __webpack_public_path__ + "roboto-latin-900.9b3766ef4a402ad3fdeef7501a456512.woff2";